import { render, staticRenderFns } from "./OrganismBackupSettings.vue?vue&type=template&id=d07ba45e&scoped=true&"
import script from "./OrganismBackupSettings.vue?vue&type=script&lang=js&"
export * from "./OrganismBackupSettings.vue?vue&type=script&lang=js&"
import style0 from "./OrganismBackupSettings.vue?vue&type=style&index=0&id=d07ba45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07ba45e",
  null
  
)

export default component.exports